"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
var react_1 = __importStar(require("react"));
var blockers_1 = require("../blockers");
var layout_1 = require("../layout");
var Form = function (props) {
    var _a = (0, react_1.useState)(null), model = _a[0], setModel = _a[1];
    var _b = (0, react_1.useState)(null), loadingText = _b[0], setLoadingText = _b[1];
    var _c = (0, react_1.useState)(null), errorText = _c[0], setErrorText = _c[1];
    var load = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, m, p, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setErrorText(null);
                    setLoadingText("Loading...");
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4, props.onLoad()];
                case 2:
                    _a = _b.sent(), m = _a[0], p = _a[1];
                    onChange(m, true);
                    setPage(p);
                    return [3, 5];
                case 3:
                    e_1 = _b.sent();
                    setErrorText(e_1.message ? e_1.message : "Unexpected error");
                    return [3, 5];
                case 4:
                    setLoadingText(null);
                    return [7];
                case 5: return [2, null];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        load();
    }, []);
    var _d = (0, blockers_1.useCommitedState)(model), commit = _d[0], isUncommited = _d[1];
    var onChange = function (model, isCommit) {
        setModel(model);
        if (isCommit) {
            commit();
        }
    };
    (0, blockers_1.useBrowserPrompt)(isUncommited);
    var _e = (0, react_1.useState)(0), page = _e[0], setPage = _e[1];
    var navigate = function (d, newPage, submit) { return __awaiter(void 0, void 0, void 0, function () {
        var e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setErrorText(null);
                    setLoadingText("Saving...");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, 8, 9]);
                    if (!!props.readOnly) return [3, 6];
                    if (!submit) return [3, 3];
                    return [4, props.onSubmit(d)];
                case 2:
                    d = _a.sent();
                    return [3, 5];
                case 3:
                    if (!(props.onSave != null)) return [3, 5];
                    return [4, props.onSave(d)];
                case 4:
                    d = _a.sent();
                    _a.label = 5;
                case 5:
                    onChange(d, true);
                    _a.label = 6;
                case 6:
                    if (typeof newPage == "number") {
                        setPage(newPage);
                        window.scroll(0, 0);
                    }
                    else if (typeof newPage == "boolean" && newPage) {
                        setTimeout(function () {
                            var postSubmitPage = props.onExit(d, submit !== null && submit !== void 0 ? submit : false);
                            if (typeof postSubmitPage === "number") {
                                setPage(postSubmitPage);
                            }
                        }, 1);
                    }
                    return [2, d];
                case 7:
                    e_2 = _a.sent();
                    setErrorText(e_2.message ? e_2.message : "Unexpected error");
                    return [3, 9];
                case 8:
                    setLoadingText(null);
                    return [7];
                case 9: return [2, null];
            }
        });
    }); };
    var print = function (d, format) { return __awaiter(void 0, void 0, void 0, function () {
        var e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    setLoadingText("Downloading...");
                    if (!(props.onPrint != null)) return [3, 2];
                    return [4, props.onPrint(d, format)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [3, 5];
                case 3:
                    e_3 = _a.sent();
                    setErrorText(e_3.message ? e_3.message : "Unexpected error");
                    return [3, 5];
                case 4:
                    setLoadingText(null);
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    var ctx = model ? {
        model: model,
        additionalDownloadButtons: props.additionalDownloadButtons,
        readOnly: props.readOnly ? true : false,
        page: page,
        onSaveEnabled: props.onSave ? true : false,
        onNavigate: navigate,
        onChange: onChange,
        onError: setErrorText,
        onLoading: setLoadingText,
        getNextPage: props.getNextPage,
        getPreviousPage: props.getPreviousPage,
        onPrint: props.onPrint ? print : undefined
    } : null;
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(layout_1.Spinner, { isLoading: loadingText ? true : false, loadingText: loadingText || undefined },
            errorText ? react_1.default.createElement(layout_1.AlertProvider, { messages: [errorText], dismiss: true, color: "danger" }) : react_1.default.createElement(react_1.default.Fragment, null),
            props.progress ? react_1.default.createElement(layout_1.ProgressBar, __assign({}, props.progress(page, model))) : react_1.default.createElement(react_1.default.Fragment, null),
            react_1.default.createElement("div", { id: "form-container" }, props.children && props.children(ctx))),
        react_1.default.createElement(blockers_1.RouterPromptModal, { block: isUncommited }));
};
exports.Form = Form;
//# sourceMappingURL=Form.js.map